module.exports = __webpack_public_path__ + "static/media/KEEPME_EVENTRACKER-GRIS-01.70e79d4c.svg";